import { render, staticRenderFns } from "./groupDocument.vue?vue&type=template&id=8ce357c6&scoped=true&"
import script from "./groupDocument.vue?vue&type=script&lang=js&"
export * from "./groupDocument.vue?vue&type=script&lang=js&"
import style0 from "./groupDocument.vue?vue&type=style&index=0&id=8ce357c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce357c6",
  null
  
)

export default component.exports